import React, { useEffect, useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { useAppConfig } from '../../context/AppConfigContext';
import { fetchData } from '../../api/api';
import Flag from 'react-world-flags';
import styles from './Settings.module.css';

import avatarDefault from '../../assets/images/avatars/base/default.png';
import avatarMan1 from '../../assets/images/avatars/base/man1.svg';
import avatarMan2 from '../../assets/images/avatars/base/man2.svg';
import avatarMan3 from '../../assets/images/avatars/base/man3.svg';
import avatarWoman1 from '../../assets/images/avatars/base/woman1.svg';
import avatarWoman2 from '../../assets/images/avatars/base/woman2.svg';
import avatarWoman3 from '../../assets/images/avatars/base/woman3.svg';
import avatarWoman4 from '../../assets/images/avatars/base/woman4.svg';
import avatarWoman5 from '../../assets/images/avatars/base/woman5.svg';

// объект с соответствием имен и изображений
const avatarMap = {
  default: avatarDefault,
  man1: avatarMan1,
  man2: avatarMan2,
  man3: avatarMan3,
  woman1: avatarWoman1,
  woman2: avatarWoman2,
  woman3: avatarWoman3,
  woman4: avatarWoman4,
  woman5: avatarWoman5,
};

const languages = ['ru', 'uk', 'en', 'de'];


const Settings = ({ userId, onSaved, welkom = false, initialTab = 'main' }) => {
  const { setUserInfo, userInfo, isGuest:temp } = useAuth();
  const { t, isTelegramWebApp, telegrambot } = useAppConfig();

  const [activeTab, setActiveTab] = useState(initialTab);

  const [baseLang, setBaseLang] = useState('');
  const [targetLang, setTargetLang] = useState('');
  const [level, setLevel] = useState('A2');
  const [showLevels, setShowLevels] = useState(false);
  const [availableLevels, setAvailableLevels]  = useState(['A2']); 

  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState('');

  const [name, setName] = useState(userInfo?.name || '');
  //const [avatar, setAvatar] = useState(userInfo?.avatar || '');
  const [avatar, setAvatar] = useState(userInfo?.avatar || 'default');
  const [telegramLinked, setTelegramLinked] = useState(!!userInfo?.telegramId);
  const [avatarFile, setAvatarFile] = useState(null); // хранит файл, если юзер загрузил новый

	const langToFlag = {
	  ru: 'RU',
	  uk: 'UA',
	  en: 'GB',
	  de: 'DE',
	};

	const mapLangToFlagKey = (lang) => {
	  if (!lang) return lang;
	  // Сервера может прислать 'ua', frontend использует 'uk'
	  if (lang === 'ua') return 'uk';
	  return lang;
	};

  useEffect(() => {
    setActiveTab(initialTab);
  }, [initialTab]);

  
	useEffect(() => {
	  const fetchSettings = async () => {
		try {
		  const result = await fetchData('/api/settings', 'POST', {
			userId,
			askSetting: true,
		  });

		  setBaseLang(result.settings.baseLanguage);
		  setTargetLang(result.settings.targetLanguage); 
		  setLevel(result.settings.level || 'A2');

		  const levels = result.settings.availableLevels || ['A2'];
		  setAvailableLevels(levels);
		  setShowLevels(levels.length > 1); // 👈 Показываем выбор уровня, только если их больше одного

		} catch {
		  setMessage(t.settings.loadFail);
		}
	  };

	  fetchSettings();
	}, [userId]);

	const handleSave = async () => {
	  if (!baseLang || !targetLang || !level) return;

	  setSaving(true);

	  try {
		await fetchData('/api/settings', 'POST', {
		  userId,
		  baseLanguage: baseLang,
		  targetLanguage: targetLang,
		  level,
		  addSetting: true,
		});

		setMessage(t.settings.success);

		setTimeout(() => {
		  setUserInfo((prev) => ({ ...prev, isNewUser: false }));
			if (onSaved) {
			  onSaved({
				baseLanguage: baseLang,
				targetLanguage: targetLang,
			  });
			}
		  setSaving(false); // ⬅️ переносим сюда
		}, 1500);

	  } catch {
		setMessage(t.settings.fail);
		setSaving(false);
	  }
	};


	const handleAvatarUpload = (e) => {
	  const file = e.target.files[0];
	  if (file) {
		setAvatarFile(file);
		const reader = new FileReader();
		reader.onloadend = () => {
		  setAvatar(reader.result); // показываем превью
		};
		reader.readAsDataURL(file);
	  }
	};

	const handleProfileSave = async () => {
	  //console.log(`userInfo?.avatar = ${userInfo?.avatar}, avatar=${avatar}`);  
	  try {
		const result = await fetchData('/api/profile/update', 'POST', {
		  userId,
		  name,
		  avatar, // тут может быть либо ключ ("man1"), либо base64-строка
		});
		setUserInfo((prev) => ({ ...prev, ...result.updatedInfo }));
		setMessage(t.settings.success);
	  } catch {
		setMessage(t.settings.fail);
	  }
	};
 
	const renderLangButton = (lang, selectedLang, onSelect, otherLang) => {
	  const flagCode = langToFlag[lang];

	  // Чтобы выделение работало и для uk/ua
	  const isSelected = mapLangToFlagKey(lang) === mapLangToFlagKey(selectedLang);
	  const isDisabled = mapLangToFlagKey(lang) === mapLangToFlagKey(otherLang);

	  return (
		<button
		  key={lang}
		  onClick={() => !isDisabled && onSelect(lang)}
		  className={`${styles.langButton} ${isSelected ? styles.langButtonSelected : ''} ${isDisabled ? styles.langButtonDisabled : ''}`}
		  disabled={isDisabled}
		>
		  <Flag code={flagCode} className={styles.flagIcon} />
		  <span className={styles.langText}>{lang.toUpperCase()}</span>
		</button>
	  );
	};


  const renderLevelButton = (lvl) => (
    <button
      key={lvl}
      onClick={() => setLevel(lvl)}
      className={`${styles.levelButton} ${lvl === level ? styles.levelButtonSelected : ''}`}
    >
      {lvl}
    </button>
  );
  
  //console.log(`https://t.me/${telegrambot}?start=connect-${userInfo.referralCode}`);
  const mainTabTitle = t.settings.mainTab || 'Настройки';
  const chooseLanguageHint = t.settings.chooseLanguageHint || 'Выберите язык';

return (
  <div className={styles.container}>
    <div className={styles.tabs}>
      <button
        className={`${styles.tabButton} ${activeTab === 'main' ? styles.activeTab : ''}`}
        onClick={() => setActiveTab('main')}
      >
        {welkom ? (
          <>
            {mainTabTitle}
            <span style={{ display: 'block', marginTop: '2px', fontStyle: 'italic', fontSize: '0.85em', fontWeight: 400 }}>
              {chooseLanguageHint}
            </span>
          </>
        ) : (
          mainTabTitle
        )}
      </button>

      {!welkom && (
        <button
          className={`${styles.tabButton} ${activeTab === 'profile' ? styles.activeTab : ''}`}
          onClick={() => setActiveTab('profile')}
        >
          {t.settings.profileTab || 'Профиль'}
        </button>
      )}
    </div>

    {activeTab === 'main' && (
      <>
        <div className={styles.section}>
          <h4>{t.settings.baseLang}</h4>
          <div>{languages.map((lang) => renderLangButton(lang, baseLang, setBaseLang, targetLang))}</div>
        </div>

        <div className={styles.section}>
          <h4>{t.settings.targetLang}</h4>
          <div>{languages.map((lang) => renderLangButton(lang, targetLang, setTargetLang, baseLang))}</div>
        </div>

        {showLevels && (
          <div className={styles.section}>
            <h4>{t.settings.level}</h4>
            <div>{availableLevels.map(renderLevelButton)}</div>
          </div>
        )}

        <button 
          onClick={handleSave}
          disabled={saving || !baseLang || !targetLang}
          className={styles.saveButton}
        >
          {saving ? t.settings.saving : t.settings.save}
        </button>
      </>
    )}

    {!welkom && activeTab === 'profile' && (
      <>
		<h2>{t.settings.profileTab || 'Профиль пользователя'}</h2>

		{temp && (
		  <div className={styles.tempWarning}>
			{t.settings.tempWarning || 'Вы используете временный аккаунт. Чтобы редактировать профиль, зарегистрируйтесь, скачайте App или зайдите через Telegram.'}
		  </div>
		)}

		<div className={styles.section}>
		  <input
			value={name}
			onChange={(e) => setName(e.target.value)}
			className={styles.styledInput}
			placeholder={t.settings.name || 'Ваше имя'}
			disabled={temp}
			maxLength={20}
			style={{ width: '20ch' }}
		  />
		</div>

				
		<div className={styles.section}>
		  <label>{t.settings.avatar || 'Аватар'}</label>
		  <div className={styles.avatarGrid}>
			<div className={styles.avatarOption} onClick={() => document.getElementById('avatarUploadInput').click()}>
			  <div className={styles.addAvatar}>+</div>
			</div>
			{['man1', 'man2', 'man3', 'woman1', 'woman2', 'woman3', 'woman4', 'woman5'].map((name) => {
			  return (
				<div
				  key={name}
				  className={`${styles.avatarOption} ${avatar === name ? styles.selectedAvatar : ''}`}
				  onClick={() => setAvatar(name)} // Сохраняем ключ, а не объект
				>
				  <img src={avatarMap[name]} alt={name} className={styles.avatarImg} />
				</div>
			  );
			})}				
		  </div>

		  <input
			id="avatarUploadInput"
			type="file"
			accept="image/*"
			onChange={handleAvatarUpload}
			className={styles.input}
			style={{ display: 'none' }}
			disabled={temp}
		  />
			{avatar && (
			  <div className={styles.avatarPreview}>
				<img 
				  src={avatarMap[avatar] || avatar} // если это base64 → покажется напрямую
				  alt="avatar preview" 
				  style={{ maxWidth: '100px', marginTop: '8px' }} 
				/>
			  </div>
			)}
		</div>
		

		{!isTelegramWebApp && (
		  <div className={styles.section}>
			<label>{t.settings.telegram || 'Telegram'}  </label>
			{telegramLinked ? (
			  <p>{t.settings.telegramLinked || 'Привязан'}</p>
			) : (
			  <button
				onClick={() => window.open(`https://t.me/${telegrambot}?start=connect-${userInfo.referralCode}`, '_blank')}
				disabled={temp}
			  >
				{t.settings.linkTelegram || 'Привязать'}
			  </button>
			)}
		  </div>
		)}
		<button
		  onClick={handleProfileSave}
		  className={styles.saveButton}
		  disabled={temp}
		>
		  {t.settings.save || 'Сохранить'}
		</button>
      </>
    )}

		{message && <div className={styles.message}>{message}</div>}
	  </div>
	);  
};

export default Settings;

//<h2>{t.settings.title}</h2>
